import { Directive, Input, computed, contentChildren, effect, input } from '@angular/core';
import { SelectAllFormFieldsDirective } from '../selectAllFormFields/select-all-form-fields.directive';

@Directive({
  selector: '[subForm]',
  standalone: true
})
export class SubFormContainerDirective extends SelectAllFormFieldsDirective {

  recursiveChilds = contentChildren(SubFormContainerDirective , {descendants: true})
  
  childsNames  = computed( () => {
    const allC =  this.recursiveChilds();
    return allC.map( c => c.name )
  })

  isChild(other: SubFormContainerDirective) {
    return this.childsNames().includes(other.name) ? -1 : 1
  }

  @Input({required: true}) name!: string;

  freezeAll = input<boolean>(false)
  
  e = effect( () => {
    // console.log(this.allChildrenFields().map( i => i.fieldInfoForFormContainer()))
    const all = this.allChildrenFields();
    if (this.freezeAll()) {
      all.forEach( field => {
        field.clearModelOnDisabled = true;
        field.disabled = true
      })
    }
    all.forEach(field => {
      field.addParentSubForm(this)
    })
  } , {allowSignalWrites: true})

  

}
